import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Logo } from 'components/shared/Logo/Logo'
import { Button } from 'components/shared/Button/Button'
import { EditButton } from './../../common/ActionButtons/EditButton/EditButton'

import {
  InterviewsCreatorHandlersContext,
  InterviewsCreatorStateContext,
} from 'components/modules/creators/TemplatesCreator/tabs/Interviews/context'
import { toTemplatesCreator } from 'ducks/router'
import { useContext } from 'hooks'

import { ArrowLeftIcon } from 'components/shared/Icon/model'

import styles from './Header.module.scss'

export const Header = ({ userName, uuid }) => {
  const state = useContext(InterviewsCreatorStateContext)!
  const handlers = useContext(InterviewsCreatorHandlersContext)!

  const { templateName } = state
  const { handleConfirmationConfirm, handleEditNameOpen } = handlers

  return (
    <Box
      className={styles.header}
      direction="column"
      justify="flex-start"
      tagName="header"
    >
      <Box align="center" className={styles.top} justify="space-between">
        <Logo
          className={styles.logo}
          redirectTo={toTemplatesCreator({ tab: 'interviews', uuid })}
          isTransparent
        />
        <span className={styles.profile}>{userName}</span>
      </Box>
      <Box align="center" className={styles.bottom} justify="space-between">
        <Box align="center" justify="center">
          <Button
            ariaLabel="back"
            className={styles.back}
            icon={ArrowLeftIcon}
            size="medium"
            variant="text"
            onClick={handleConfirmationConfirm}
          />
          <h1 className={styles.title}>
            {t`Interview template editor: ${templateName}`}
          </h1>
          <EditButton
            ariaLabel="edit template name"
            className={styles.edit}
            size="small"
            onClick={handleEditNameOpen}
          />
        </Box>
        <Button
          label={t`Finish`}
          size="medium"
          variant="outlined"
          onClick={handleConfirmationConfirm}
        />
      </Box>
    </Box>
  )
}
